import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import ApplicationSerializer from 'lumen/serializers/application';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class BeniBreakdownPeriodSegmentSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    ranking: { embedded: 'always' },
    index: { embedded: 'always' },
    pickup: { embedded: 'always' },
  };
}
